import { Draft, PayloadAction } from '@reduxjs/toolkit';
import { IBuilder } from '../types';

export const setSelectedDateInput = (
  state: Draft<IBuilder>,
  action: PayloadAction<{
    newDateInput: IBuilder['dateInput'];
  }>,
) => {
  const { newDateInput } = action.payload;
  state.dateInput = newDateInput;
};
